import { useEffect, useState } from "react";
import axios from "axios";
import { Flame, TrendingUp, TrendingDown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function StreakBadge() {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API}/streak`).then(r => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-amber-400/10 px-3 py-1 text-xs ring-1 ring-amber-400/30" data-testid="streak-badge" title={`Longest: ${s.longest_streak} days`}>
      <Flame className="h-3.5 w-3.5 text-amber-300" />
      <span className="text-amber-200">{s.current_streak} day{s.current_streak === 1 ? "" : "s"} streak</span>
    </div>
  );
}

export function ReachWidget() {
  const [r, setR] = useState(null);
  useEffect(() => { axios.get(`${API}/analytics/reach?days=7`).then(x => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  const Up = (r.wow_delta_pct ?? 0) >= 0 ? TrendingUp : TrendingDown;
  return (
    <div className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-4" data-testid="reach-widget">
      <div className="mb-2 flex items-center justify-between">
        <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">7-day reach</p>
        {r.wow_delta_pct !== null && (
          <span className={`inline-flex items-center gap-1 text-xs ${r.wow_delta_pct >= 0 ? "text-emerald-300" : "text-red-300"}`}>
            <Up className="h-3 w-3" /> {r.wow_delta_pct >= 0 ? "+" : ""}{r.wow_delta_pct}%
          </span>
        )}
      </div>
      <p className="text-2xl font-semibold text-zinc-100">{r.total_reach.toLocaleString()}</p>
      <p className="text-xs text-zinc-500">people reached</p>
      <div className="mt-3 flex flex-wrap gap-1.5 text-[10px]">
        {Object.entries(r.per_platform).map(([p, v]) => (
          <span key={p} className="rounded-full bg-zinc-800 px-2 py-0.5 text-zinc-300"><span className="capitalize">{p}</span>: {v.toLocaleString()}</span>
        ))}
      </div>
      {r.note && <p className="mt-2 text-[10px] text-zinc-600">{r.note}</p>}
    </div>
  );
}
